import React from 'react';
import {useIntl} from 'react-intl';
import classNames from 'classnames';
import Empty from '../../../_common/components/Empty';
import {DataItemRadioFixed} from '../../../_common/components/DataItemRadio';
import {FieldDataItemCheckboxFixed} from '../../../_common/components/DataItemCheckbox';
import styles from './styles.module.scss';

const Headers = () => {
  const {formatMessage} = useIntl();
  const fieldCustomerNameLabel = formatMessage({
    id: 'invoice-orders-popup-create-customer-customerName', defaultMessage: 'Customer name'
  });
  const fieldCustomerIDLabel = formatMessage({
    id: 'invoice-orders-popup-create-customer-ID', defaultMessage: 'Customer ID'
  });
  const fieldIdNumberLabel = formatMessage({
    id: 'invoice-orders-popup-create-customer-idNumber', defaultMessage: 'Id number'
  });
  const fieldCustomerPhoneNumber = formatMessage({
    id: 'invoice-orders-popup-create-customer-phoneNumber', defaultMessage: 'Phone'
  });
  const fieldCustomerEmail = formatMessage({
    id: 'invoice-orders-popup-create-customer-email', defaultMessage: 'Email'
  });
  const fieldCustomerAddress = formatMessage({
    id: 'invoice-orders-popup-create-customer-address', defaultMessage: 'Address'
  });

  return (
    <div
      className={styles.customersGridHeader}
    >
      <div className={styles.headerDesktop}>
        <div className={styles.headerCell}>
          {fieldCustomerIDLabel}
        </div>
        <div className={styles.headerCell}>
          {fieldCustomerNameLabel}
        </div>
        <div className={styles.headerCell}>
          {fieldIdNumberLabel}
        </div>
        <div className={styles.headerCell}>
          {fieldCustomerPhoneNumber}
        </div>
        <div className={styles.headerCell}>
          {fieldCustomerEmail}
        </div>
        <div className={styles.headerCell}>
          {fieldCustomerAddress}
        </div>
        <div className={styles.headerCell}/>
      </div>
      <div className={styles.headerMobile}>
        <div className={styles.headerCell}>
          {fieldCustomerIDLabel}
          {fieldCustomerNameLabel}
        </div>
        <div className={styles.headerCell}>
          {fieldIdNumberLabel}
          {fieldCustomerPhoneNumber}
        </div>
        <div className={styles.headerCell}>
          {fieldCustomerEmail}
          {fieldCustomerAddress}
        </div>
        <div className={styles.headerCell}/>
      </div>
    </div>
  );
};

const GridRow = ({idNumber, allowInvoiceDeal, _id, email, address, name, phone, fax, formikProps, index}) => {
  return (
    <div className={styles.customersGridRow} key={index}>
      <div className={styles.desktop}>
        <div className={styles.cell}>{_id}</div>
        <div className={styles.cell}>{name}</div>
        <div className={styles.cell}>{idNumber}</div>
        <div className={styles.cell} dir="ltr">
          <div>{phone}</div>
          <div>{fax}</div>
        </div>
        <div className={styles.cell}>{email}</div>
        <div className={styles.cell}>{address}</div>
        <div className={classNames(styles.cell, `text-center`)}>
          <DataItemRadioFixed
            name={`selectedCustomerID`}
            id={`selectedCustomerID-${_id}`}
            value={_id}
            onChange={(e) => {
              formikProps.setFieldValue('selectedCustomerID', e.target.value)
              formikProps.setFieldValue('customerAllowInvoiceDeal', allowInvoiceDeal)
            }}
            disabled={formikProps.values.createNewCustomer}
          />
        </div>
      </div>
      <div className={styles.mobile}>
        <div className={styles.cell}>
          <div>{_id}</div>
          <div className={'text-wrap'}>{name}</div>
        </div>
        <div className={styles.cell}>
          <div>{idNumber}</div>
          <div dir={'ltr'}>{phone}</div>
          <div dir={'ltr'}>{fax}</div>
        </div>
        <div className={styles.cell}>
          <div>{email}</div>
          <div>{address}</div>
        </div>
        <div className={classNames(styles.cell, `text-center`)}>
          <DataItemRadioFixed
            name={`selectedCustomerID`}
            id={`selectedCustomerID-${_id}`}
            value={_id}
            onChange={(e) => formikProps.setFieldValue('selectedCustomerID', e.target.value)}
            disabled={formikProps.values.createNewCustomer}
          />
        </div>
      </div>
    </div>
  );
};

const CustomersGrid = ({
                         gridData,
                         formikProps
                       }) => {
  const {formatMessage} = useIntl();

  const mapGridRow = (gridData) => gridData.map((item, index) => (
    <GridRow
      {...item}
      formikProps={formikProps}
      index={index}
      key={index}
    />
  ));

  return (
    <>
      <Headers/>
      <div
        className={`mb-6 ${gridData.length > 5 ? 'h-250px overflow-auto' : ''}`}
      >
        {gridData?.length > 0
          ? <div>{mapGridRow(gridData)}</div>
          : <div className={'my-6'}><Empty/></div>
        }
      </div>
      <FieldDataItemCheckboxFixed
        name={'createNewCustomer'}
        label={formatMessage({id: 'invoice-orders-popup-create-customer-selectNone', defaultMessage: 'Select none'})}
        containerClassname={'my-2 d-flex align-items-center'}
        labelClassname={'mx-2'}
      />
    </>
  );
};

export default CustomersGrid;